<app-accounting-template
        [title]="title"
        [apiUrl]="apiUrl"
        [tableInfo]="info"
        [type]="'INVOICE'"
        [rowActionsSettings]="rowActionsSettings"
        [topActionsSettings]="topActionsSettings"
        [filtersSettings]="filtersSettings"
></app-accounting-template>
